import {FrontendRoutes} from '../constants';
import {useLocation} from 'react-router-dom';

const useIsSpecial = () => {
	const location = useLocation();

	return [
		FrontendRoutes.COUNTDOWN,
		FrontendRoutes.AFTER_EVENT_MESSAGE,
		FrontendRoutes.UNAUTHORIZED,
		FrontendRoutes.LOGOUT,
		FrontendRoutes.SOCIAL_WALL_MODERATION,
	].includes(location.pathname);
};

export default useIsSpecial;